import { ComponentsLayout } from './layout'
import {
  BasicExample,
  DemandExample,
  UserExample,
  AdminExample,
  CustomActionsExample,
  DynamicActionsExample,
  MultipleToolbarsExample,
  DashboardToolbarExample,
  MinimalToolbarExample,
  HorizontalDockExample,
  FullDemandToolbarExample,
} from '../../components/FloatingToolbar/examples'

export const FloatingToolbarPage = () => {
  return (
    <ComponentsLayout
      title='Floating Toolbar'
      description='Barra de ferramentas flutuante para ações rápidas e contextuais'
    >
      <div className='space-y-16 grid grid-cols-1 md:grid-cols-2 gap-8'>
        {/* Exemplo Básico */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Uso Básico</h2>
          <p className='text-gray-600 mb-6'>
            Implementação simples da FloatingToolbar com ações básicas.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <BasicExample />
            </div>
          </div>
        </section>

        {/* Ações Personalizadas */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Ações Personalizadas</h2>
          <p className='text-gray-600 mb-6'>
            FloatingToolbar com ações customizadas e funcionalidades específicas.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <CustomActionsExample />
            </div>
          </div>
        </section>

        {/* Ações Dinâmicas */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Ações Dinâmicas</h2>
          <p className='text-gray-600 mb-6'>
            Toolbar com ações que mudam dinamicamente baseadas no contexto.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <DynamicActionsExample />
            </div>
          </div>
        </section>

        {/* Múltiplas Toolbars */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Múltiplas Toolbars</h2>
          <p className='text-gray-600 mb-6'>
            Exemplo com múltiplas toolbars funcionando simultaneamente.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <MultipleToolbarsExample />
            </div>
          </div>
        </section>

        {/* Dashboard Toolbar */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Dashboard Toolbar</h2>
          <p className='text-gray-600 mb-6'>
            Toolbar especializada para dashboards e painéis de controle.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <DashboardToolbarExample />
            </div>
          </div>
        </section>

        {/* Toolbar Minimalista */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Toolbar Minimalista</h2>
          <p className='text-gray-600 mb-6'>
            Versão minimalista da toolbar com design limpo e funcional.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <MinimalToolbarExample />
            </div>
          </div>
        </section>

        {/* Toolbar de Demandas */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Toolbar de Demandas</h2>
          <p className='text-gray-600 mb-6'>
            Toolbar especializada para gerenciamento de demandas.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <DemandExample />
            </div>
          </div>
        </section>

        {/* Toolbar de Demandas Completa (todas as ações) */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Toolbar de Demandas (Completa)</h2>
          <p className='text-gray-600 mb-6'>
            Demonstração com todas as opções visíveis por padrão para apresentação das funcionalidades.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <FullDemandToolbarExample />
            </div>
          </div>
        </section>

        {/* Toolbar de Usuário */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Toolbar de Usuário</h2>
          <p className='text-gray-600 mb-6'>Toolbar com ações específicas para usuários.</p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <UserExample />
            </div>
          </div>
        </section>

        {/* Toolbar de Administrador */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Toolbar de Administrador</h2>
          <p className='text-gray-600 mb-6'>
            Toolbar com funcionalidades administrativas avançadas.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <AdminExample />
            </div>
          </div>
        </section>

        {/* Dock Horizontal */}
        <section className='bg-white rounded-xl shadow-sm p-8'>
          <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Dock Horizontal</h2>
          <p className='text-gray-600 mb-6'>
            Toolbar em estilo dock que expande horizontalmente ao passar o mouse, mostrando todas as
            ações disponíveis.
          </p>
          <div className='relative min-h-[300px] bg-gray-50 rounded-lg p-6 flex items-center justify-center'>
            <div className='relative w-full h-full flex items-center justify-center'>
              <HorizontalDockExample />
            </div>
          </div>
        </section>

      </div>
              {/* Seção de código */}
              <div className='mt-12 bg-white p-6 rounded-lg shadow-sm border'>
          <h3 className='text-lg font-semibold text-gray-900 mb-4'>Como usar</h3>
          <div className='bg-gray-50 p-4 rounded-md'>
            <pre className='text-sm text-gray-800 overflow-x-auto'>
              {`import { 
  FloatingToolbar, 
  DemandToolbar, 
  UserToolbar, 
  AdminToolbar,
  createToolbarAction 
} from '../../components/FloatingToolbar'

// Uso básico
<FloatingToolbar
  actions={[
    createToolbarAction('edit', 'Editar', <HiPencil />, () => {}),
    createToolbarAction('delete', 'Excluir', <HiTrash />, () => {})
  ]}
/>

// Toolbar especializada para demandas
<DemandToolbar
  onEdit={() => console.log('Editar')}
  onReturn={() => console.log('Devolver')}
  onResolve={() => console.log('Solucionar')}
  onAssignToSelf={() => console.log('Puxar para si')}
/>

// Configurações avançadas
<FloatingToolbar
  actions={actions}
  position="top-right"
  animation="slide"
  theme="dark"
  size="large"
  showLabels={true}
  maxVisibleActions={5}
/>

// Dock horizontal personalizado
const HorizontalDockExample = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  return (
    <div 
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
      className="flex items-center gap-2 p-3 bg-black/20 backdrop-blur-xl rounded-2xl"
    >
      {actions.map((action, index) => (
        <div
          key={action.id}
          className={\`transition-all duration-300 \${
            isExpanded ? 'w-12 h-12' : index === 0 ? 'w-10 h-10' : 'w-0 h-0'
          }\`}
        >
          {action.icon}
        </div>
      ))}
    </div>
  );
};`}
            </pre>
          </div>
        </div>
    </ComponentsLayout>
  )
}
